import React, { Suspense, useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { NavBar,Result,Skeleton } from 'antd-mobile'

const ua = navigator.userAgent.toLowerCase()
//const ua = 'micromessenger'
export default function HouseLoan() {
  const [title,setTitle] = useState(null)
  const navigate = useNavigate()
  const { pathname } = useLocation()
  useEffect(() => {
    document.title = '士翔房产经纪'
    if(pathname.includes('bestlist')){
      setTitle('优选房源')
    }else if(pathname.includes('bestdetail')){
      setTitle('房源详情')
    }else{
      setTitle('士翔房产经纪') 
    }
  },[pathname])
  return (
    <>
      {
        ua.includes('micromessenger') || pathname.includes('best')? (
          <Suspense fallback={
              <>
                <Skeleton.Title animated />
                <Skeleton.Paragraph lineCount={5} animated />
              </>
            }
          >
            {
              !pathname.includes('home') ? (
                <NavBar 
                  className='crm-header' 
                  backArrow={ !pathname.includes('login') && !pathname.includes('bestlist')} 
                  onBack={()=>navigate(-1)}
                >
                  {title}
                </NavBar>
              ) : null
            }
            <Outlet/>
          </Suspense>

        ) : (
          <Result
            status='warning'
            title='警告'
            description='请在微信内打开页面'
          />
        )
      }
    </>
  )
}